import React from 'react';
import { Box, Button, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import CustomTextField from '../../components/forms/CustomTextField';

import CustomeMultlineForm from '../../components/forms/CustomeMultlineForm';

const createSubcategoryValidationSchema = Yup.object({
    sub_category_name: Yup.string().required('Sub category name is required').max(20),
    description: Yup.string(),
});

const CreateSubcategory = () => {
    return (
        <>
            <Formik
                initialValues={{
                    sub_category_name: '',
                    description: '',
                }}
                validationSchema={createSubcategoryValidationSchema}
                onSubmit={() => {}}
            >
                {(formik) => (
                    <Form>
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid item sm={12}>
                                <CustomTextField
                                    name="sub_category_name"
                                    label={'Sub category name'}
                                    color="primary"
                                />
                            </Grid>
                            <Grid item sm={12}>
                                <CustomeMultlineForm
                                    name="description"
                                    label={'Sub category description'}
                                    color="primary"
                                    rows={5}
                                />
                            </Grid>
                            <Grid item sm={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        className="app-btn"
                                        onClick={formik.handleSubmit}
                                    >
                                        Create sub category
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default CreateSubcategory;
